import {
  buildDocChatFeedbackRequest,
  type DocChatFeedbackReason,
  type DocChatFeedbackSaved,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatFeedback'
import { z } from 'zod'

const savedFeedbackSchema = z.object({
  id: z.string().min(1),
  model: z.string().nullable().optional(),
})

export interface SubmitDocChatFeedbackInput {
  conversationId: string
  turnId: string
  siteId: string
  reasons: DocChatFeedbackReason[]
  comment: string
  selectedText?: string | null
  forecastVersion: string | null
  url: string | null
}

export interface DocChatFeedbackClient {
  post(url: string, data?: unknown): Promise<{ data: unknown }>
}

/**
 * Save the feedback. The backend snapshots the rated answer and posts the
 * feedback to #power-docchat-feedback itself.
 */
export async function submitDocChatFeedback(
  client: DocChatFeedbackClient,
  powerBackendUrl: string,
  input: SubmitDocChatFeedbackInput
): Promise<DocChatFeedbackSaved> {
  const response = await client.post(
    `${powerBackendUrl}/api/v2/docchat/feedback`,
    buildDocChatFeedbackRequest(input)
  )
  const saved = savedFeedbackSchema.parse(response.data)
  return { id: saved.id, model: saved.model ?? null }
}
